'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronright from '@common/icon/SvgChevronright';
import useEmblaCarousel from 'embla-carousel-react';
import { Image } from '@/components/client';
interface PhotoReviewItem {
  imageUrl: string;
  reviewId: string;
}
interface MarketPhotoReviewGridProps {
  photoReviews: PhotoReviewItem[];
  totalCount: number;
  onPhotoClick?: (reviewId: string) => void;
  onMoreClick?: () => void;
}
export const MarketPhotoReviewGrid = t0 => {
  const $ = _c(22);
  const {
    photoReviews,
    totalCount,
    onPhotoClick,
    onMoreClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  if (totalCount < 1) {
    return null;
  }
  let t2;
  if ($[1] !== totalCount) {
    t2 = <h4 className="font-600 text-Gray-900 typo-body2">포토후기 {totalCount}</h4>;
    $[1] = totalCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SvgChevronright className="size-12" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onMoreClick) {
    t4 = <button type="button" className="flex items-center gap-4 font-700 text-Gray-600 typo-caption1" onClick={onMoreClick}>더보기{t3}</button>;
    $[4] = onMoreClick;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="flex items-center justify-between py-12">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onPhotoClick || $[10] !== photoReviews) {
    let t7;
    if ($[12] !== onPhotoClick) {
      t7 = (t8, index) => {
        const {
          imageUrl,
          reviewId
        } = t8;
        return <div key={`${reviewId}-${index}`} className="flex-[0_0_auto]"><button type="button" className="relative size-104 overflow-hidden border border-Gray-black/5" onClick={() => onPhotoClick?.(reviewId)}><Image src={imageUrl} alt={"\uD3EC\uD1A0\uD6C4\uAE30 \uC774\uBBF8\uC9C0"} width={208} height={208} className="size-full object-cover object-center" /></button></div>;
      };
      $[12] = onPhotoClick;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t6 = photoReviews.map(t7);
    $[9] = onPhotoClick;
    $[10] = photoReviews;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="flex gap-8">{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== emblaRef || $[17] !== t7) {
    t8 = <div className="w-full overflow-hidden" ref={emblaRef}>{t7}</div>;
    $[16] = emblaRef;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t5 || $[20] !== t8) {
    t9 = <div className="flex flex-col">{t5}{t8}</div>;
    $[19] = t5;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};